module.exports = __webpack_public_path__ + "assets/modal-lottery-question-bg-en-2e9ad472.png";